export class EmailValidator {
    private static readonly validationRegEx: RegExp = new RegExp(
      '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9' +
      ']{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-ZÀ-ž\\-0-9]+\\.)+[a-zA-ZÀ-ž]{2,}))$');

    public validate(email: string) {
        return EmailValidator.validationRegEx.test(email);
    }

}

const EMAIL_VALIDATOR_INSTANCE = new EmailValidator();

export {EMAIL_VALIDATOR_INSTANCE};
